var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"small"},[_c('MultiChartBase',{attrs:{"chartData":_vm.datacollection2,"options":_vm.graphOpts}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }